var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elder-stepper",attrs:{"data-current-step":_vm.active.id}},[(_vm.breadcrumb)?_c('div',{staticClass:"elder-stepper__breadcrumbs"},[_vm._l((_vm.value),function(item,index){return [(index > 0)?_c('Icon',{key:'arrow-' + index,staticClass:"elder-stepper__breadcrumb-arrow",attrs:{"icon":_vm.icon}}):_vm._e(),_c('div',{key:index,staticClass:"elder-stepper__breadcrumb",class:{ 'elder-stepper__breadcrumb--active': _vm.isActive(item) }},[_vm._t("breadcrumb",function(){return [_c('button',{staticClass:"elder-stepper__breadcrumb-button",attrs:{"type":"button","disabled":item.disabled},on:{"click":function($event){return _vm.state.set(item.id)}}},[_c('span',{staticClass:"elder-stepper__breadcrumb-icon"},[(item.icon)?_c('Icon',{attrs:{"icon":item.icon,"size":"sm"}}):[_vm._v(_vm._s(index + 1))]],2),_c('span',[_vm._v(_vm._s(item.label))])])]},{"item":item,"isActive":_vm.isActive(item),"index":index,"navigate":() => _vm.state.set(item.id)})],2)]})],2):_vm._e(),_vm._t("before",null,null,{
      meta: _vm.meta,
      next: _vm.next,
      prev: _vm.prev,
    }),_c(_vm.transition ? 'transition-group' : 'div',{tag:"component",staticClass:"elder-stepper__component",attrs:{"name":_vm.transition,"tag":"div"}},_vm._l((_vm.value),function(item){return _c(item.component,_vm._g(_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isActive(item)),expression:"isActive(item)"}],key:item.id,tag:"component",scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default",null,null,{
            meta: _vm.meta,
            item,
            next: _vm.next,
            prev: _vm.prev,
            isActive: _vm.isActive(item),
          })]},proxy:true},{key:"navigation",fn:function(scopedProps){return [_vm._t("navigation",null,null,{
            meta: _vm.meta,
            item,
            next: _vm.next,
            prev: _vm.prev,
            isActive: _vm.isActive(item),
            ...scopedProps,
          })]}}],null,true)},'component',{
        ...(item.props || {}),
        step: item,
        isActive: _vm.isActive(item),
        ..._vm.$attrs,
      },false),{
        ...(item.listeners || {}),
        next: _vm.next,
        prev: _vm.prev,
        ..._vm.$listeners,
      }))}),1),_vm._t("after",null,null,{
      meta: _vm.meta,
      next: _vm.next,
      prev: _vm.prev,
    })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }